import { httpRequest } from "@/utils/HttpRequest";
import { appHttpRequest } from "@/utils/AppHttpRequest";
import {
    StatisticsSearchFields,
    StatisticsFields, IStatistics, ScheduleFields,
    TurnoverReceiptFields, ReceiptPaymentFields,
    TradeAmountTodayFields, TradeAmountMonthFields,
    InvoiceInfoFields, InventoryRatioFields
} from "./HomeTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import { ciHttpRequest } from "@/utils/CiHttpRequest";

class HomeService {

    //管理版-统计接口
    async homePageStatistics(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/statistics";
        return await httpRequest.post<StatisticsFields>(apiUrl, params);
    }

    //管理版-库存统计
    async statistics(searchVo: { shopId: string, userBranch: string }) {
        let apiUrl = "/scm2/inventory/summary/report/statistics";
        if (searchVo.userBranch === 'ci') {
            apiUrl = "/ci-storage/stock/details/total/amount";
            return await ciHttpRequest.post<IStatistics>(apiUrl, searchVo, { timeout: 30000 });
        }
        else {
            if (searchVo.userBranch === 'vrm') {
                apiUrl = "/vrm2/stock/details/total/amount";
            }
            else if (searchVo.userBranch === 'bcm') {
                apiUrl = "/bcm/stock/details/total/amount";
            }
            return await appHttpRequest.post<IStatistics>(apiUrl, searchVo);
        }
    }

    //管理版-待办事项统计
    async homePageSchedule(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/schedule";
        return await httpRequest.post<ScheduleFields>(apiUrl, params);
    }

    //管理版-营业额、应收金额统计 1门店 2实体
    async turnoverReceiptAmount(param: StatisticsSearchFields) {
        let apiUrl = "/homePage/getTurnoverReceiptAmountByShopCode";
        if (param.type == 2) {
            apiUrl = "/homePage/getTurnoverReceiptAmountByBentity";
        }
        return await httpRequest.post<TurnoverReceiptFields[]>(apiUrl, param);
    }

    //管理版-收付款金额统计 1门店 2实体
    async receiptPayment(param: StatisticsSearchFields) {
        let apiUrl = "/homePage/getReceiptPaymentVoByShopCode";
        if (param.type == 2) {
            apiUrl = "/homePage/getReceiptPaymentVoByBentity";
        }
        return await httpRequest.post<ReceiptPaymentFields[]>(apiUrl, param);
    }

    //管理版-当日营业额
    async homePageTradeAmountToday(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/getDateAmountByTradeTypeName";
        return await httpRequest.post<TradeAmountTodayFields[]>(apiUrl, params);
    }

    //管理版-营业额、应收金额根据按月统计
    async homePageTradeAmountMonth(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/getTurnoverReceiptAmountByMonthly";
        return await httpRequest.post<TradeAmountMonthFields[]>(apiUrl, params);
    }

    //管理版-发票信息统计
    async homePageInvoiceInfo(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/getInvoiceInfo";
        return await httpRequest.post<InvoiceInfoFields[]>(apiUrl, params);
    }

    //管理版-库存占比
    async homePageInventoryRatio(params: StatisticsSearchFields) {
        const apiUrl = "/homePage/inventoryRatio";
        return await httpRequest.post<InventoryRatioFields[]>(apiUrl, params);
    }

    // 设置管理
    async set(params: { userCode: string }) {
        const apiUrl = `/setUp/findByUserCode`
        return await httpRequest.post<any[]>(apiUrl, params)
    }
    async setUpdate(details: any) {
        const apiUrl = `/setUp/update`
        return await httpRequest.post<boolean>(apiUrl, details)
    }
    //导出
    async export(shopCode: string) {
        const appPageUrl = `/report/export/${shopCode}`;
        return await httpRequest.postFile<boolean>(appPageUrl, {}, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const homeService = new HomeService();
